module.exports = __webpack_public_path__ + "62zMRbUQkDDyPCw-E/illo-couple-phone.svg";